jQuery(document).ready(function($) {
	console.log ("hello there!");
});